import styles from './styles.module.scss'
import Section from '../../../elements/Section'
import Button from '../../../elements/Button'
import IconGallery from '/public/icons/icon-gallery.svg'
import { useModalContext } from '../../../../providers/modalProvider'
import Modal from './components/Modal'
import { getRandom } from '../../../helpers/getRandom'
import { useState, useEffect } from 'react'
import GalleryGrid from '../../../custom/GalleryGrid'
import { useAuthContext } from '../../../../providers/authProvider'
import IconExternal from '/public/icons/icon-external.svg'
import { getS3Url } from '../../../helpers/getS3Url'
import isEmpty from 'lodash-es/isEmpty'
import { useRouter } from 'next/router'
import { useResponsive } from '../../../../providers/ResponsiveContext'

const Gallery = ({ property, background = 'white', translations }) => {
  const router = useRouter()
  const { isMobile } = useResponsive()
  const { setContent, handleShowModal, setVariant } = useModalContext()
  const { isAuthorized } = useAuthContext()
  const [images, setImages] = useState([])

  if (property?.pictures?.length < 4) {
    return
  }

  useEffect(() => {
    if (property.cloudflare_gallery && !isEmpty(property.cloudflare_gallery)) {
      const gallery =
        property.cloudflare_gallery.length < 5
          ? property.cloudflare_gallery
          : getRandom(property.cloudflare_gallery, 5)
      const images = gallery.map((picture, index) =>
        getS3Url(picture, index === 1 ? (isMobile ? '640' : '960') : '640')
      )
      setImages(images)
    } else {
      setImages(getRandom(property?.pictures, 5))
    }
  }, [])

  return (
    <Section variant={[background, 'p0']}>
      <GalleryGrid
        images={images}
        button={
          <div className={styles.buttons}>
            <Button
              arrow={false}
              onClick={() => {
                setContent(
                  <Modal translations={translations} property={property} />
                )
                setVariant(['prevent-outside-close'])
                handleShowModal()
              }}
              variant={['primary-blue', 'xs']}
              prepend={<IconGallery width={35} height={32} />}
            >
              {translations.browse[router.locale]}
            </Button>

            {property.ontraport_script &&
              property.ontraport_script.startsWith('https') && (
                <Button
                  href={property.ontraport_script}
                  appendIcon={<IconExternal />}
                  variant={['color-primary']}
                  target="_blank"
                >
                  3D Tour
                </Button>
              )}

            {isAuthorized && property?.attachment?.unbranded_video && (
              <Button
                href={property?.attachment?.unbranded_video}
                appendIcon={<IconExternal />}
                variant={['color-primary']}
                target="_blank"
              >
                Unbranded Video
              </Button>
            )}

            {isAuthorized && property?.attachment?.gallery && (
              <Button
                href={property?.attachment?.gallery}
                appendIcon={<IconExternal />}
                variant={['color-primary']}
                target="_blank"
              >
                {translations.download[router.locale]}
              </Button>
            )}
          </div>
        }
      />
    </Section>
  )
}

export default Gallery
